import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface ResolveConversationTRPCInput {
  Id: string;
}

export const useResolveConversationTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.conversation.resolve.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.comment.commentsByConversationId.queryKey(),
        });
      },
    }),
  });

  return {
    resolveConversation: async (
      input: ResolveConversationTRPCInput
    ): Promise<{ Id: string }> => mutation.mutateAsync(input),
    loading: mutation.isPending,
    error: mutation.error,
  };
};
